import React from 'react';
import { toast } from 'react-toastify';

import { useDispatch, useSelector } from 'react-redux';
import { forgotPasswordAction, verifyPasswordOtpAction } from '../../redux/actions/userActions';
import { validateEmail, validatePassword } from '../../utils/validators';
import { FORGOT_PASSWORD_RESET, VERIFY_PASSWORD_OTP_RESET } from '../../redux/constants/userConstants';

const useForgotPasswordFunctions = history => {
  const dispatch = useDispatch();

  const [step, setStep] = React.useState(1);
  const [email, setEmail] = React.useState({ value: '', error: '', validated: false });
  const [OTP, setOTP] = React.useState({ value: '', error: '', validated: false });
  const [showPassword, setShowPassword] = React.useState(false);
  const [password, setPassword] = React.useState({ value: '', error: '', validated: false });

  const forgotPassword = useSelector(state => state.forgotPassword);
  const verifyPasswordOTP = useSelector(state => state.verifyPasswordOTP);

  React.useEffect(() => {
    if (forgotPassword && !forgotPassword.loading && forgotPassword.userInfo && forgotPassword.userInfo.status === 'success') {
      toast.success('An email is sent to your email. Please check');
      dispatch({ type: FORGOT_PASSWORD_RESET });
      setStep(2);
    }

    if (forgotPassword && !forgotPassword.loading && forgotPassword.error) {
      setEmail(prevMobData => ({ ...prevMobData, error: forgotPassword.error, validated: false }));
    }
  }, [forgotPassword, dispatch]);

  React.useEffect(() => {
    if (verifyPasswordOTP && !verifyPasswordOTP.loading && verifyPasswordOTP.userInfo && verifyPasswordOTP.userInfo.status === 'success') {
      dispatch({ type: VERIFY_PASSWORD_OTP_RESET });
      toast.success('Your password successfully changed.');
      setStep(1);
      setEmail({ value: '', error: '', validated: false });
      setOTP({ value: '', error: '', validated: false });
      setPassword({ value: '', error: '', validated: false });
      history.push('/login');
    }

    if (verifyPasswordOTP && !verifyPasswordOTP.loading && verifyPasswordOTP && verifyPasswordOTP.error) {
      toast.error(verifyPasswordOTP.error);
      setOTP(prevMobData => ({ ...prevMobData, error: 'Please enter valid OTP', validated: false }));
    }
  }, [verifyPasswordOTP, dispatch, history]);

  const handleSendEmail = e => {
    e.preventDefault();

    if (email.value === '' || email.value.trim() === '') {
      setEmail({ ...email, error: 'Email is required', validated: false });
    } else if (!validateEmail(email.value)) {
      setEmail({ ...email, error: 'Invalid email entered', validated: false });
    } else {
      dispatch(forgotPasswordAction(email.value));
    }
  };

  const onVerifyOtpHandler = e => {
    e.preventDefault();

    if (email.value === '' || email.value.trim() === '') {
      setEmail({ ...email, error: 'Email is required', validated: false });
    } else if (!validateEmail(email.value)) {
      setEmail({ ...email, error: 'Invalid email entered', validated: false });
    } else if (OTP.value === '' || OTP.value.trim() === '') {
      setOTP({ ...OTP, error: 'Please enter code sent to your email', validated: false });
    } else if (OTP.value.length < 6) {
      setOTP({ ...OTP, error: 'Invalid code entered', validated: false });
    } else if (!validatePassword(password.value)) {
      setPassword({ ...password, error: 'Please enter your new password', validated: false });
    } else if (password.value.length < 8) {
      setPassword({ ...password, error: 'Password must have atleast 8 characters', validated: false });
    } else {
      dispatch(verifyPasswordOtpAction(email.value, OTP.value, password.value));
    }
  };

  return { step, setStep, email, setEmail, OTP, setOTP, showPassword, setShowPassword, password, setPassword, onVerifyOtpHandler, handleSendEmail, forgotPassword };
};

export default useForgotPasswordFunctions;
